import { callApiToServer } from "../callApi";

export async function addBalanceIntoUserAccount(
  authtoken,
  request_id,
  body,
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    }
    console.log("payload",body);
    let endUrl = "v1/auth/approve-balance-requests/"+request_id;
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
    console.log("responseData",responseData);
      
    return responseData;
  }catch(err) {
    throw err;
  }
}


